import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  datepickerPreselectedDate: any;

  constructor() { }
}
